import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum OrganizationActivityColumn {
    CREATED_AT = "createdAt",
    ACTOR = "actor",
    ACTION = "action",
    CLIENTS = "clients",
    ACTIONS = "actions",
}

const CreatedAtColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationActivityColumn.CREATED_AT),
});
const ActorColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationActivityColumn.ACTOR),
});
const ActionColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationActivityColumn.ACTION),
});
const ClientsColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationActivityColumn.CLIENTS),
});
const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationActivityColumn.ACTIONS),
});

export const OrganizationActivityViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ORGANIZATION_ACTIVITY),
    columns: z.array(
        z.discriminatedUnion("id", [
            CreatedAtColumnSchema,
            ActorColumnSchema,
            ActionColumnSchema,
            ClientsColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type OrganizationActivityView = z.infer<
    typeof OrganizationActivityViewSchema
>;
